import React from 'react';

import Pages from './basic_page';
class Model extends Pages {
    render() {
        return (
            <>
            <h1 className='des_mod'>
                Model
            </h1>
        <div className='pageholder'>
            <div className='leftmenu'>
                <div>Model</div>
                <button onClick={() => this.scroll(this.firstRef)}>Methods</button>
                <button onClick={() => this.scroll(this.secondRef)}>Nutrition abundance</button>
                <button onClick={() => this.scroll(this.thirdRef)}>Dynamics of E.coli concentration</button>
                <button onClick={() => this.scroll(this.fourthRef)}>Dynamics of S.cerevisiae concentration </button>
                <button onClick={() => this.scroll(this.fifthRef)}>Dynamics of EPI concentration</button>
                <button onClick={() => this.scroll(this.sixthRef)}>Overall Model</button>
                <button onClick={() => this.scroll(this.seventhRef)}>Results</button>
            </div>
            <div className='righttext'>
                <div className='P1' ref={this.firstRef}>
                    <div className='text_wrap'>
                    <h3 >Methods</h3>
                    <p>We have designed a dynamical model of our co-culture system. This model is inspired by the iterative coculture model in Duesseldorf 2018 (hereinafter referred to as the D2018 Model), which considered the nutrition as an limiting factor in a co-culture system.</p>
                    <p>Our model is based on nutrition competition in co-culture system: Propagation of both E.coli and S.ceresiviae leads to the consumption of nutrition, also, propagation of E.coli is inhibited by Cloxicillin concentration as regulated by EPI. </p>
                    <div className='img_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-background.png' alt="图1" />
                    </div>
                    </div>
                </div>
                <div className='P2' ref={this.secondRef}>
                    <div className='text_wrap'>
                    <h3 >Nutrition abundance</h3>
                    <p>Nutrition will be consumed by both E.coli and S.ceresiviae. We assume that 1 unit of E.coli will consume A<sub>b</sub> units of nutrition per hour , and one unit of S.ceresiviae will consume A<sub>y</sub> units of nutrition per hour. So the change in nutrition abundance c will take the following form:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-1.jpg' alt="图2" />
                    </div>
                    <p>where [B] is the concentration of E.coli and [Y] is the concentration of S.ceresiviae. Also, we assume that in an environment with more abundant nutrition, both E.coli and S.ceresiviae will consume nutrition more rapidly in order to grow faster. More specifically, we assume that the consumption rate A<sub>b</sub> and A<sub>y</sub> is proportional to nutrition abundance, c, for simplicity.</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-2.jpg' alt="图3" />
                    </div>
                    <p>So the dynamics of nutrition abundance is as follows:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-3.jpg' alt="图4" />
                    </div>
                    <p>E.coli and S.cerevisiae both consume various types of nutrition, so it’s difficult to measure nutrition abundance in practice. Thus, we just set initial abundance to 1 as the scaled concentration of their major carbon source i.e. glucose.</p>
                    </div>
                </div>
                <div className='P3' ref={this.thirdRef}>
                <div className='text_wrap'>
                    <h3 >Dynamics of E.coli concentration</h3>
                    <p>Dynamics of E.coli could be separated into three parts, as follows:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-4.jpg' alt="图5" />
                    </div>
                    <p>The first term is growth rate, the second term is natural death rate and the last term is death rate caused by interaction of EPI and Cloxicillin. We’ll discuss the form of each term in detail below.</p>
                    <h6>Growth </h6>
                    <p>Organisms couldn’t grow at an infinitely high rate when the nutrition is extremely abundant. So we assume a maximum growth rate of gb per unit of E.coli and used a Hill function to describe this saturate phenomenon. The form of this term is as follows:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-5.jpg' alt="图6" />
                    </div>
                    <p>Where n<sub>1</sub> and k<sub>b</sub> are parameters in Hill function.</p>
                    <h6>Natural Death</h6>
                    <p>At the beginning, we assumed the death rate per unit of E.coli is a constant, which couldn’t fit our experiment data well. So we referred to the Logistic model of population growth and set death rate proportional to the quadratic of E.coli concentration with a scaling factor d<sub>bb</sub>, which results in the following equation:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-6.jpg' alt="图7" />
                    </div>
                    <h6>Death Caused by Interaction of EPI and Cloxicillin</h6>
                    <p>At the beginning we assumed that the death rate caused by interaction of EPI and Cloxicillin is just proportional to the concentration of EPI and Cloxicillin, which results in the following equation:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-7.jpg' alt="图8" />
                    </div>
                    <p>Where [T] is the concentration of Cloxicillin.</p>
                    <p>But this form seemed to be oversimplified and couldn’t match experimental data well. So we need to study the mechanism of the inhibition effect of EPI and antibiotics deeper to construct a better model.</p>
                    <p>The overall idea is quite simple (as shown below): EPI will interfere the formation of functional trimer of AcrB, so bacteria will pump antibiotics out of the cell slower when EPI are added. This reduction of efflux rate will actually cause an increase of intracellular concentration of antibiotics, which is directly correlated to the death rate caused by EPI and Cloxicillin. </p>
                    <div className='img_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-mechanism.jpg' alt="图9" />
                    </div>
                    <p>In our demonstration, EPI will act as a competitive inhibitor of AcrB and interfere the formation of functional trimer and thus inhibit the drug resistance of E.coli (See more detail in Design section). So we consider the following chemical process:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-8.jpg' alt="图10" />
                    </div>
                    <p>Where E represents EPI molecule, A represents free AcrB monomer.</p>
                    <p>At equilibrium:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-9.jpg' alt="图11" />
                    </div>
                    <p>Also, assume the total amount of AcrB monomers</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-10.jpg' alt="图12" />
                    </div>
                    <p>is a constant. So we could derive the following formula through two equations above:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-11.jpg' alt="图13" />
                    </div>
                    <p>Where</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-12.jpg' alt="图14" />
                    </div>
                    <p>We assume the efflux of antibiotics is proportional to the amount of functional AcrB ([A<sub>3</sub>]) and intracellular concentration of antibiotics ([T]<sub>in</sub>), while influx of antibiotics is a simple diffusion, which is proportional to the difference of extracellular and intracellular concentration of antibiotics ([T]-[T]<sub>in</sub>, where [T] represents the total concentration of supplied antibiotics):</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-13.jpg' alt="图15" />
                    </div>
                    <p>So at equilibrium, efflux=influx:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-14.jpg' alt="图16" />
                    </div>
                    <p>So we could derive the intracellular concentration of antibiotics in equilibrium:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-15.jpg' alt="图17" />
                    </div>
                    <p>Where</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-16.jpg' alt="图18" />
                    </div>
                    <p>The correlation between death rate and intracellular antibiotics are S-shaped, so we use a Hill function to describe this correlation:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-17.jpg' alt="图19" />
                    </div>
                    <h6>Overall form</h6>
                    <p>According to the above derivation, The overall form of dynamics of E.coli could be described as:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-18.jpg' alt="图20" />
                    </div>
                </div>
                </div>

                <div className='P4' ref={this.fourthRef}>
                <div className='text_wrap'>
                    <h3 >Dynamics of S.cerevisiae concentration </h3>
                    <p>Organisms couldn’t grow at an infinitely high rate when the nutrition is extremely abundant. So we assume a maximum growth rate of g<sub>y</sub> per unit of S.cerevisiae and used a Hill function to describe this saturate phenomenon.</p>                   
                    <p>At the beginning, we assumed the death rate per unit of S.cerevisiae is a constant, which couldn’t fit our experiment data well. So we referred to the Logistic model of population growth and set death rate proportional to the quadratic of S.cerevisiae concentration with a scaling factor d<sub>yy</sub>.</p>
                    <p>So the dynamics of S.cerevisiae concentration is as follows: </p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-19.jpg' alt="图21" />
                    </div>
                    <p>Where n<sub>3</sub> and k<sub>y</sub> are parameters of the Hill function.</p>                
                </div>
                </div>

                <div className='P5'  ref={this.fifthRef}>
                <div className='text_wrap'>
                    <h3>Dynamics of EPI concentration</h3>
                    <p>We just assumed that EPI is generated at a rate that proportional to S.cerevisiae concentration and degraded at a constant rate, which results in the following equation:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-20.jpg' alt="图22" />
                    </div>
                    <p>Where se is the secretion rate per unit of S.cerevisiae, and be is the degradation rate of EPI.</p>              
                </div>
                </div>
                <div className='P6' ref={this.sixthRef}>
                <div className='text_wrap'>
                    <h3 >Overall Model</h3>
                    <p>The overall model consists of four ODEs:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-21.jpg' alt="图23" />
                    </div>
                </div>
                </div>
                <div className='P7' ref={this.seventhRef}>
                <div className='text_wrap'>
                    <h3 >Results</h3>
                    <p>This model is a very simple model which describe the dynamics in the co-culture system. However, it offered us a proof that our system is sensible to efficiency of EPIs.</p>
                    <p>The efficiency of EPI could be measured by the its ability to bind AcrB molecule, which is the constant k<sub>1</sub> above. k<sub>1</sub> is inversely proportional to both d<sub>0</sub> and d<sub>1</sub>, so when the efficiency of EPI increases, k<sub>1</sub> will increase, so d<sub>1</sub> and d<sub>0</sub> will reduce proportionally. So we could define the efficiency of EPI as follows:</p>

                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-22.jpg' alt="图24" />
                    </div>
                    <p>It is proved that the ratio of S.cerevisiae and E.coli when co-cultured for 14h (which is the co-culture period in our experiment) is sensitive to the efficiency of peptide, as shown below:</p>
                    <div className='formula_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/modeling-formula-23.jpg' alt="图25" />
                    </div>
                    <br></br>
                    <div className='img_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/mod-25.png' alt="图26" />
                    </div>
                    </div>
               </div>
            </div>
        </div>
            </>

  );
    }
};

export default Model;
